import { Container, ContainerProps } from '@chakra-ui/react';

const PageContainer = ({
  children, maxW = '7xl', minH = '100vh', p = 8, ...props
}: ContainerProps): JSX.Element => (
  <Container maxW={maxW} minH={minH} p={p} {...props}>
    {children}
  </Container>
);

export default PageContainer;
